import { Badge, Button, Modal, Space, Typography } from "antd";
import type { FC } from "react";
import type { SeoDeployResultRow } from "../types";

const { Text } = Typography;

interface SeoDeployResultsModalProps {
  results: SeoDeployResultRow[] | null;
  onClose: () => void;
}

export const SeoDeployResultsModal: FC<SeoDeployResultsModalProps> = ({ results, onClose }) => {
  return (
    <Modal
      title="Deployment results"
      open={Boolean(results)}
      onCancel={onClose}
      footer={
        <Button type="primary" onClick={onClose}>
          Close
        </Button>
      }
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        {(results ?? []).map((result) => (
          <Space key={result.environmentId} style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
            <Text>{result.environmentLabel}</Text>
            <Space direction="vertical" size={0} style={{ textAlign: "right" }}>
              <Badge status={result.status === "success" ? "success" : "error"} text={result.status === "success" ? "Success" : "Failed"} />
              {result.message && (
                <Text type="secondary" style={{ fontSize: 12 }}>
                  {result.message}
                </Text>
              )}
            </Space>
          </Space>
        ))}
      </Space>
    </Modal>
  );
};
